module.exports = __webpack_public_path__ + "static/media/momotitle.b2210277.jpg";